import { post } from '@/apis/http'
import store from '@/store'

// 判断是否有权限进入管理后台
export function queryRoleTypeByStudioId(data) {
    return post(`${store.state.config.SGKT_URL}/wkds/studio/queryRoleTypeByStudioId`, data)
}

/**
 * @description: 活动列表
 * @param {*} data
 * @return {*}
 */
 export function pageQueryActivityListForManage(data) {
    return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/pageQueryActivityListForManage`, data)
}

/**
 * @description: 活动列表
 * @param {*} data
 * @return {*}
 */
 export function pageQueryActivityListNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/pageQueryActivityListNnl`, data)
}
/**
 * 查询填报信息选择列表
 * @param data
 * @returns {*}
 */
export function getFillInfosNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/getFillInfos`, data)
}

/**
 * 新建能力大赛活动
 * @param data
 * @returns {*}
 */
export function saveRecActivityInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/saveRecActivityInfo`, data)
}

/**
 * 上下架能力大赛活动
 * @param data
 * @returns {*}
 */
export function upDownActivity(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/upDownActivity`, data)
}

/**
 * 删除能力大赛活动
 * @param data
 * @returns {*}
 */
export function delActivityInfoById(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/delActivityInfoById`, data)
}

/**
 * 删除能力大赛活动
 * @param data
 * @returns {*}
 */
export function delActivityInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/delActivityInfo`, data)
}

/**
 * 查询能力大赛活动详情
 * @param data
 * @returns {*}
 */
export function getActivityInfoById(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/getActivityInfoByIdNnl`, data)
}

/**
 * 修改能力大赛活动
 * @param data
 * @returns {*}
 */
export function updateRecActivityInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendActivity/updateRecActivityInfo`, data)
}

export function saveGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/saveGroupInfo`, data)
}
/**
 * 查询活动下组别
 * @param data
 * @returns {*}
 */
export function listGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/listGroupInfo`, data)
}
/**
 * 查询父类下子组别
 * @param data
 * @returns {*}
 */
 export function listChildGroupInfoNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/listChildGroupInfo`, data)
}

/**
 * 新增子类活动组别
 * @param data
 * @returns {*}
 */
export function saveChildGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/saveChildGroupInfo`, data)
}

/**
 * 删除活动组别
 * @param data
 * @returns {*}
 */
export function deleteGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/deleteGroupInfo`, data)
}

/**
 * 查询单个组别详情
 * @param data
 * @returns {*}
 */
export function getGroupById(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/getGroupById`, data)
}

/**
 * 编辑活动组别
 * @param data
 * @returns {*}
 */
export function updateGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/updateGroupInfo`, data)
}

/**
 * 活动组别排序
 * @param data
 * @returns {*}
 */
export function sortGroupInfo(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendGroup/sortGroupInfo`, data)
}

/**
 * 新增推荐单位
 * @param data
 * @returns {*}
 */
export function saveRecommendWorkplace(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/saveRecommendWorkplace`, data)
}
// 设置推荐指数
export function RecommendPostSetTargetForWk(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/setTargetNumForWk`, data)
}
// 设置推荐管理员
export function RecommendPostSetUnitManager(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/setRecWorkUnitManager`, data)
}


/**
 * 分页查询推荐单位信息
 * @param data
 * @returns {*}
 */
export function pageQueryWorkPlaceListForManage(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/pageQueryWorkPlaceListForManage`, data)
}

/**
 * 删除推荐单位
 * @param data
 * @returns {*}
 */
export function delWorkPlace(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/delWorkPlace`, data)
}

/**
 * 查询推荐单位详情
 * @param data
 * @returns {*}
 */
export function getWorkPlaceById(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/getWorkPlaceById`, data)
}

/**
 * 编辑推荐单位
 * @param data
 * @returns {*}
 */
export function updateRecommendWorkplace(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/updateRecommendWorkplace`, data)
}

/**
 * 根据单位代码判断单位是否存在
 * @param data
 * @returns {*}
 */
export function checkWkCodeIsRight(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/checkWkCodeIsRight`, data)
}

/**
 * 重置密码
 * @param data
 * @returns {*}
 */
export function resSettingWkPwd(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/resSettingWkPwd`, data)
}

/**
 * 分页查询选手列表
 * @param data
 * @returns {*}
 */
export function pageQueryPlayerListForManage(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/pageQueryPlayerListForManage`, data)
}

/**
 * 删除选手信息
 * @param data
 * @returns {*}
 */
export function delPlayer(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/delPalyerById`, data)
}

/**
 * 选手管理受理/退回
 * @param data
 * @returns {*}
 */
export function updatePlayerStatusForId(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/updatePlayerStatusForId`, data)
}

/**
 * 专家列表查询
 * @param data
 * @returns {*}
 */
export function pageQueryExpertListForManage(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/pageQueryExpertListForManage`, data)
}

/**
 * 查询推荐单位列表
 * @param data
 * @returns {*}
 */
export function getWorkPlaceList(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/getWorkPlaceList`, data)
}

/**
 * 新增专家
 * @param data
 * @returns {*}
 */
export function insertExpert(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/insertExpert`, data)
}

/**
 * 判断单位代码是否已经存在
 * @param data
 * @returns {*}
 */
 export function checkWkCodeIsRightNnl(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/checkWkCodeIsRight`, data)
}
/**
 * 资源列表查询
 * @param data
 * @returns {*}
 */
export function pageQueryResource(data) {
  return post(`${store.state.config.SGKT_URL}/open/recommendcollect/pageQueryResource`, data)
}

/*--专家库--*/
  // 列表
export function ExpertLibraryPostPageQuery(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/pageQueryExpertPool`, data)
}
  // 新增
export function ExpertLibraryPostInsertExpert(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/insertExpert`, data)
}
  // 查询字典
export function ExpertLibraryPostDictInfoList(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recommendworkplace/getDictInfoList`, data)
}
  // 获取专家可选列表
export function ExpertLibraryPostBaseTenantUser(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/user/pageQueryTenantUser`, data)
}
  // 修改专家状态
export function ExpertLibraryPostUpdateStatus(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/updExpertStatus`, data)
}
  // 逻辑删除专家
export function ExpertLibraryPostDeleteFake(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/updDelStatus`, data)
}
  // 物理删除专家
export function ExpertLibraryPostDeletePhysic(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/physicDelPlayer`, data)
}
  // 查询专家详情
export function ExpertLibraryPostPlayerInfos(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/getResRecommendPlayerFills`, data)
}
  // 编辑专家
export function ExpertLibraryPostUpdPlayerFills(data) {
  return post(`${store.state.config.SGKT_URL}/wkds/recUser/updPlayerFills`, data)
}
// 根据关键字获取教育局列表
export function queryOrganGetEducationList(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/organ/getEducationList`, data)
}
// 查询学校列表
export function queryOrganGetSchoolList(data) {
  return post(`${store.state.config.SGKT_URL}/basedata/school/pageListSchoolInfoByCondition`, data)
}
/*--专家库--*/



// WEBPACK FOOTER //
// ./src/apis/activity/admin.js